export default "__VITE_ASSET__DgvQ1M3K__"